"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrialsMeta_1 = __importDefault(require("../models/TrialsMeta"));
const Location_1 = __importDefault(require("../models/Location"));
const Treatment_1 = __importDefault(require("../models/Treatment"));
const Sample_1 = __importDefault(require("../models/Sample"));
const TimeModel_1 = __importDefault(require("../models/TimeModel"));
class TrialsService {
    constructor() {
        this.meta = new TrialsMeta_1.default();
        this.counters = [];
        this.times = [];
        this.locations = [];
        this.treatments = [];
        this.samples = [];
        this.data = {
            meta: {
                name: '',
                approvedAt: '',
                totalSamples: 0,
                totalAssignedSamples: 0,
                crop: {
                    id: 0,
                    logoName: '',
                    name: '',
                },
            },
            counters: [],
            times: [],
            locations: [],
            treatments: [],
            samples: []
        };
        this.isLoadingCallInitialData = false;
    }
    async callInitialData(params) {
        this.isLoadingCallInitialData = true;
        try {
            const call = await fetch(`/data/tracking/trials/${params.proposalId}/project/${params.projectId}/configuration`);
            const response = await call.json();
            response.meta = response.details;
            response.locations = response.locations.map((l) => {
                const treatment_details = l.treatment_details.map((t, j) => {
                    return {
                        'meta': {
                            'name': t.treatmentName,
                            'control': t.is_control,
                            'treatmentID': t.treatmentId,
                        },
                        'times': t.times
                    };
                });
                return Object.assign(Object.assign({}, l), { 'treatment_details': treatment_details });
            });
            this.data = response;
            this.fillWithData();
        }
        catch (error) {
            console.log(error);
        }
        this.isLoadingCallInitialData = false;
    }
    async callProjectSamples(params) {
        this.isLoadingCallInitialData = true;
        try {
            const call = await fetch(`/data/tracking/trials/${params.proposalId}/project/${params.projectId}/samples?show_all=true`);
            const response = await call.json();
            this.samples = response.map((s) => new Sample_1.default(s));
        }
        catch (error) {
            console.log(error);
        }
        this.isLoadingCallInitialData = false;
    }
    fillWithData() {
        this.meta = new TrialsMeta_1.default(this.data.meta);
        this.counters = this.data.counters;
        this.times = this.data.times;
        this.locations = this.data.locations.map((l) => new Location_1.default(l));
        this.treatments = this.data.treatments.map((t) => new Treatment_1.default(t));
    }
    updateLocationTime(loc) {
        const locIx = this.locations.findIndex((l) => l.id === loc.id);
        this.locations[locIx].currentTime = loc.currentTime;
    }
    updateSentSamples(payload) {
        const locIx = this.locations.findIndex((l) => l.id === payload.location_id);
        let treatIx = this.locations[locIx].treatment_details.findIndex((t) => t.meta.treatmentID === payload.treatment_id);
        if (treatIx === -1)
            treatIx = 0;
        this.locations[locIx].treatment_details[treatIx].times[payload.time].logisticProcess.sentDateAt = new Date().toDateString();
    }
    updateSampleAssignation(payload) {
        const payloads = [];
        payloads.push(payload);
        payloads.forEach((payload) => {
            console.log(payload);
            // Meta
            this.meta.totalAssignedSamples += payload.samples.length;
            // Times
            this.times[payload.time].samplesAssigned += payload.samples.length;
            // Location
            const locIx = this.locations.findIndex((l) => l.id === payload.location_id);
            /*             this.locations[locIx].time_details[payload.time].samplesTotalThisTime = 15;
                        this.locations[locIx].time_details[payload.time].samplesAssigned = 15; */
            this.locations[locIx].time_details[payload.time].samplesAssigned += payload.samples.length;
            // Treatment
            let treatIx = this.locations[locIx].treatment_details.findIndex((t) => t.meta.treatmentID === payload.treatment_id);
            if (treatIx === -1)
                treatIx = 0;
            this.locations[locIx].treatment_details[treatIx].times[payload.time].samplesAssignedForTime += payload.samples.length;
            // Samples
            this.samples.forEach((s) => {
                if (payload.samples.includes(s.sample_code)) {
                    s.is_available = false;
                }
            });
        });
    }
    get locationsForLine() {
        const widthView = screen.width;
        const widthCard = 487;
        const numElements = Math.trunc(widthView / widthCard);
        return numElements;
    }
    get linesStructure() {
        const numElementLocations = this.locations.length;
        const numLines = Math.ceil(numElementLocations / this.locationsForLine);
        const linesObjects = [];
        for (let index = 0; index < numLines; index++) {
            if (index === 0 && numLines > 1) {
                linesObjects.push([this.locationsForLine]);
            }
            else if (index === 0 && numLines > 1) {
                linesObjects.push([
                    numElementLocations -
                        this.locationsForLine * (numLines - 1),
                ]);
            }
            else if (index === numLines - 1) {
                linesObjects.push([
                    numElementLocations -
                        this.locationsForLine * (numLines - 1),
                ]);
            }
            else {
                linesObjects.push([this.locationsForLine]);
            }
        }
        return linesObjects;
    }
    get collectMeta() {
        return this.meta;
    }
    get collectTimes() {
        const times = [];
        this.times.forEach((item) => {
            times.push(new TimeModel_1.default(item));
        });
        return times;
    }
    get collectLocations() {
        const locations = [];
        this.locations.forEach((item) => {
            locations.push(new Location_1.default(item));
        });
        /*         if(locations.length > 0) {
                    console.log(locations[0].treatment_details);
                    locations[1].treatment_details[1].times[1].samplesTotalThisTime = -1
                }  */
        return locations;
    }
    get collectSamples() {
        return this.samples;
    }
    get collectTreatments() {
        return this.treatments;
    }
    get collectCounters() {
        return this.counters;
    }
    get isLoading() {
        return this.isLoadingCallInitialData;
    }
}
exports.default = TrialsService;
